import React from 'react';
import { Button, Box } from '@rsos/components/capstone/base';
import Dropdown from '@rsos/components/capstone/base/Dropdown';
import {
  DropdownDialog,
  DropdownBody,
  DropdownList,
  DropdownListItem,
  DropdownSection,
  DropdownListSectionItem,
} from '@rsos/components/capstone/base/Dropdown/DropdownComponents';
import { RoleAvatarColorCircle, AvatarContainer } from '../common.styles';
import { AssignDropdownBaseSecondaryText } from './AssignDataSourcesDropdown.styles';

const AssignDataSourcesDropdown = ({
  handleAssign,
  values,
  roles,
  resetForm,
  isDisabled,
}) => {
  const assignPermission = (onDropdownClose, id) => {
    const payload = {
      permission_names: values.dataSources,
      role_ids: id ? [id] : roles.map(r => r.id),
    };
    handleAssign(payload, resetForm, onDropdownClose);
  };

  const AssignButton = ({ selected, onClick }) => {
    return (
      <Box width={136}>
        <Button
          btnType="primary"
          onClick={onClick}
          selected={selected}
          type="button"
          grow
          disabled={isDisabled}
        >
          Assign
        </Button>
      </Box>
    );
  };
  return (
    <>
      <Dropdown triggerElement={AssignButton} zIndex={2} triggerOnClose>
        {onDropdownClose => (
          <DropdownDialog width="150px" maxHeight="250px">
            <DropdownBody>
              <DropdownListSectionItem>
                <DropdownSection sectionTitle="Assign to: " borderless>
                  <DropdownList borderless>
                    <DropdownListItem
                      onClick={() => assignPermission(onDropdownClose)}
                    >
                      <AssignDropdownBaseSecondaryText>
                        All Roles
                      </AssignDropdownBaseSecondaryText>
                    </DropdownListItem>
                    {roles.map(r => {
                      return (
                        <DropdownListItem
                          onClick={() =>
                            assignPermission(onDropdownClose, r.id)
                          }
                          key={r.id}
                        >
                          <Box horizontal flow={7}>
                            <AvatarContainer>
                              <RoleAvatarColorCircle bg={r.avatar_bg_color} />
                            </AvatarContainer>
                            <AssignDropdownBaseSecondaryText>
                              {r.name}
                            </AssignDropdownBaseSecondaryText>
                          </Box>
                        </DropdownListItem>
                      );
                    })}
                  </DropdownList>
                </DropdownSection>
              </DropdownListSectionItem>
            </DropdownBody>
          </DropdownDialog>
        )}
      </Dropdown>
    </>
  );
};

export default AssignDataSourcesDropdown;
